import RoutePath from 'router/path';

import { makeLabels } from 'utils/i18n';

export const KEYS = {
  ROUTE_MATCH: `${RoutePath.Pwc.Accounts.ById}/:route`,
};

const NAMESPACE = 'page.merchant.accountSettings.refundAccounts.topUpModal';
export const LABELS = makeLabels(
  {
    TITLE: ['modal.title', 'Top Up Your Refund Float Account'],
    ACTIONS: {
      CANCEL: ['actions.cancel', 'Cancel'],
      DONE: ['actions.done', 'Done'],
    },
    IMPORTANT_SECTION: {
      NOTE_1: ['importantSection.note1PaymentRails', 'Accepted payment methods: <b>{{paymentRails}}</b>.'],
      NOTE_1_FALLBACK: ['importantSection.note1Fallback', 'Use the bank transfer details below to top up your refund account.'],
      NOTE_2: [
        'importantSection.note2',
        'Enter the following <b>Transfer Memo</b> in the transfer notes of your bank transfer for it to be successfully processed.',
      ],
    },
    FIELDS: {
      ACCOUNT_NUMBER: ['fields.accountNumber', 'Account Number'],
      ROUTING_NUMBER: ['fields.routingNumber', 'Routing Number'],
      TRANSFER_MEMO: ['fields.transferMemo', 'Transfer Memo'],
      BR_CODE: ['fields.brCode', 'BR Code'],
      IBAN: ['fields.iban', 'IBAN'],
      CLABE: ['fields.clabe', 'CLABE'],
      BRE_B_KEY: ['fields.breBKey', 'Bre-B Key'],
      ACCOUNT_HOLDER_NAME: ['fields.accountHolderName', 'Account Holder Name'],
      BANK_NAME: ['fields.bankName', 'Bank Name'],
      BANK_ADDRESS: ['fields.bankAddress', 'Bank Address'],
      BENEFICIARY_NAME: ['fields.beneficiaryName', 'Beneficiary Name'],
      BENEFICIARY_ADDRESS: ['fields.beneficiaryAddress', 'Beneficiary Address'],
    },
    GENERIC_ERROR: ['genericError', 'Something went wrong. Please try again later.'],
    INSUFFICIENT_BALANCE_TITLE: ['insufficientBalanceTitle', 'Insufficient Refund Balance'],
    INSUFFICIENT_BALANCE_MESSAGE: [
      'insufficientBalanceMessage',
      'The refund float account does not have enough funds to issue this refund.' +
        '<br />Please top up the account using the instructions below.',
    ],
  },
  NAMESPACE,
);
